export const environment = {
  production: false,
  environmentName: 'test',
  apiBaseUrl: 'https://test-api.stronx.app/api',
};
